import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

interface Props {
  caminho: string;
  aoAmpliar: (url: string) => void;
}

// Miniatura de 58px com URL assinada curta (5 minutos), gerada na hora.
// Tocar abre a foto em tela cheia.
export default function FotoAssinada({ caminho, aoAmpliar }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [falhou, setFalhou] = useState(false);

  useEffect(() => {
    let ativo = true;
    setUrl(null);
    setFalhou(false);
    (async () => {
      try {
        const { data } = await supabase.storage
          .from('presencas')
          .createSignedUrl(caminho, 300);
        if (ativo) {
          if (data?.signedUrl) setUrl(data.signedUrl);
          else setFalhou(true);
        }
      } catch {
        if (ativo) setFalhou(true);
      }
    })();
    return () => {
      ativo = false;
    };
  }, [caminho]);

  if (falhou) {
    return (
      <div className="flex h-[58px] w-[58px] shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-400">
        <i className="ri-image-line text-xl" />
      </div>
    );
  }

  if (!url) {
    return (
      <div className="flex h-[58px] w-[58px] shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-400">
        <i className="ri-loader-4-line animate-spin text-lg" />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => aoAmpliar(url)}
      className="h-[58px] w-[58px] shrink-0 cursor-zoom-in overflow-hidden rounded-lg bg-secondary-50"
    >
      <img src={url} alt="Foto enviada" className="h-full w-full object-cover object-top" />
    </button>
  );
}